const Xas = {
  symbol: 'xas',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm9.992-17.529L26 14.47l-3.826-6.462.002-.007H9.922l.002.008-.002-.002L6 14.563l.039.006-.032.013L16.097 26l.426-.52zm-13.136.459l6.423-.011 2.122 3.635-5.363 6.162-5.353-6.112zm-2.778 2.98l-2.602-2.972 4.361-.007zm9.723-3.846l-3.038-5.205 4.883-.01 3.11 5.207zm4.771.846l-2.56 2.942-1.713-2.935zm-5.791-.844l-5.42.009 2.729-4.62zm-8.399-5.194l5.04-.01-3.08 5.214-5.06.009z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#faa00d" r="16"/><path d="M25.992 14.471l-9.469 11.01-.425.519L6.007 14.582l.032-.013L6 14.563l3.922-6.557.002.002L9.922 8h12.254l-.002.007L26 14.47zm-13.136.459l-2.17 3.674 5.352 6.112 5.363-6.162-2.122-3.635zm-2.778 2.98l1.76-2.979-4.362.007zm9.723-3.846l4.954-.008-3.11-5.208-4.882.01zm4.771.846l-4.273.007 1.713 2.935zm-5.791-.844L16.09 9.454l-2.73 4.62zm-8.399-5.194l-3.1 5.213 5.06-.009 3.08-5.214z" fill="#fff" fill-rule="nonzero"/></g>`;
  }
};
export default Xas;
